import { render, staticRenderFns } from "./bjjl.vue?vue&type=template&id=1b8167fe&scoped=true&"
import script from "./bjjl.vue?vue&type=script&lang=js&"
export * from "./bjjl.vue?vue&type=script&lang=js&"
import style0 from "./bjjl.vue?vue&type=style&index=0&id=1b8167fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8167fe",
  null
  
)

export default component.exports